import React from 'react';
import { debounce } from 'throttle-debounce';
import Autosuggest from 'react-autosuggest';
import LoadingSpinner from './LoadingSpinner';
import FadeOutErrorMessage from './FadeOutErrorMessage';

export default class AutoSuggestInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            searchValue: '',
            noSuggestions: false,
            suggestions: []
        };

        this.onSuggest = debounce(500, this.onSuggest);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.suggestions) {
            this.setState({
                suggestions: nextProps.multi ?
                    nextProps.suggestions.filter(suggestion => nextProps.selection.map(sel => sel[this.props.suggestionKey]).indexOf(suggestion[this.props.suggestionKey]) < 0)
                    : nextProps.suggestions
            });
        }
    }

    onChange(event, { newValue, method }) {
        this.setState({
            value: '',
            searchValue: method === "type" ? newValue : this.state.searchValue
        });
        if (!this.props.multi) {
            this.props.update(this.props.name, '');
        }
    }

    async onSuggest(input) {
        if (input.value.length > 2) {
            await this.props.getSuggestions(input.value);
            this.setState({ noSuggestions: !this.state.suggestions.length });
        }
    }

    onSelectSuggestion(event, { suggestion }) {
        if (suggestion.incomplete && !this.props.allowIncomplete) return;

        this.setState({ searchValue: suggestion[this.props.suggestionValue] });
        this.props.update(this.props.name, this.props.multi ? [...this.props.selection, suggestion] : suggestion);
    }

    clearSuggestions() {
        this.setState({
            noSuggestions: false
        });
        if (this.props.multi && this.state.searchValue) {
            this.setState({ searchValue: '' });
        }
        this.props.clearSuggestions();
    }

    getSuggestionAction(suggestion) {
        return <span onClick={e => e.stopPropagation()} >
            {this.props.suggestionAction(suggestion)}
        </span>
    }

    render() {
        return (
            <div>
                {this.props.title && <label className="input-label">{this.props.title}</label>}
                <div className="search-input">
                    <i className="material-icons">search</i>
                    <Autosuggest
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this.onSuggest.bind(this)}
                        onSuggestionsClearRequested={this.clearSuggestions.bind(this)}
                        getSuggestionValue={s => s[this.props.suggestionValue]}
                        onSuggestionSelected={this.onSelectSuggestion.bind(this)}
                        renderSuggestion={s => <div className={(s.incomplete && !this.props.allowIncomplete) ? "disabled-hover" : ''}>
                            <p>
                                <span className="bold-text inline-block">{s.name}</span>
                                {s.incomplete && <span className="tag incomplete">Incomplete</span>}
                                {!!this.props.suggestionAction && this.getSuggestionAction(s)}
                            </p>
                            <span>{s.address}</span>
                            <span>{s.phoneNumber.join(", ")}</span>
                        </div>}
                        inputProps={{
                            className: this.props.className,
                            disabled: this.props.disabled,
                            onChange: this.onChange.bind(this),
                            value: this.state.searchValue
                        }}
                    />

                    {this.props.loadingSuggestions && <LoadingSpinner height="12" />}
                    <FadeOutErrorMessage
                        show={!this.props.loadingSuggestions && this.state.searchValue && this.state.noSuggestions}
                        message="No Suggestions" />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/AutoSuggestInput.jsx